import { Router } from '@angular/router';
import { MenuService } from './../../../../themes/services/menu.service';
import { Component, OnInit } from '@angular/core';
import { AuthService } from '@uw/core/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { ProfileInformationDialogComponent } from '@uw/shared/components';
import { environment } from '@uw-env/environment';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss'],
    imports: [MatButton, TranslateModule]
})
export class LandingPageComponent implements OnInit {

  get user() {
    return this.authService.getUser();
  }

  constructor(private menuService: MenuService,
    private authService: AuthService,
    private router: Router,
    private readonly _dialog: MatDialog
  ) {
    this.menuService.showDonarSubMenu(true);
  }

  ngOnInit(): void {
  }

  onPasswordChange() {
    this.router.navigate(['/private', { outlets: { sidebar: ['change-password'] } }]);
  }

  onProfileInformation() {
    this._dialog.open(ProfileInformationDialogComponent, {
      panelClass: 'uw-form-dialog-panel',
      disableClose: true,
      closeOnNavigation: false
    });
  }

  //revert for 6.5 release
  // onLogout() {
  //   let isSSOUser = this.authService.getUser()?.isSSOUser;
  //   if (isSSOUser){
  //     this.authService.sso_saml_logOut();
  //   } else {
  //     let lang = localStorage.getItem('lang');
  //     this.authService.logOut().subscribe(
  //       _ => {
  //         if (isSSOUser) {
  //           window.location.href = `${environment.donorSiteUrl}/main/sso-login?loggedout=true&isSSOUser=${isSSOUser}&lang=${lang}`;
  //         } else {
  //           window.location.href = `${environment.donorSiteUrl}?loggedout=true&lang=${lang}`;
  //         }
  //       }
  //     );
  //   }
  // }

  onLogout() {
    let isSSOUser = this.authService.getUser()?.isSSOUser;
    let lang = localStorage.getItem('lang');
    this.authService.logOut().subscribe(
      _ => {

        if (isSSOUser) {
          window.location.href = `${environment.donorSiteUrl}/main/sso-login?loggedout=true&isSSOUser=${isSSOUser}&lang=${lang}`;
        } else {
          window.location.href = `${environment.donorSiteUrl}?loggedout=true&lang=${lang}`;
        }

      }
    );
  }


}
